import {http} from "@/api/http";
import {API_URL, ID_API_URL} from "@/api/base";


export async function getCompanies(){
    return await http.get(
        `${ID_API_URL}/v1/company/user_companies`
    )
}

export async function getCompany(company_id){
    return await http.get(
        `${ID_API_URL}/v1/company/${company_id}/info`
    )
}

export async function updateCompany(company_id, data){
    return await http.post(
        `${ID_API_URL}/v1/company/${company_id}/update`,
        {...data, id: company_id}
    )
}

/**
 * Налог и часовой пояс компании (хранятся в Profit)
 * @param {string} company_id - ID компании
 * @returns {Promise} Promise с данными {tax_type, tax_percent, timezone}
 */
export async function getCompanySettings(company_id){
    return await http.get(
        `${API_URL}/v1/company/${company_id}/settings`
    )
}

/**
 * @param {string} company_id - ID компании
 * @param {Object} data - { tax_type?, tax_percent?, timezone? }
 * @returns {Promise}
 */
export async function updateCompanySettings(company_id, data){
    return await http.patch(
        `${API_URL}/v1/company/${company_id}/settings`,
        data
    )
}
